const pageTitles = [
  { path: '/ab/*', title: 'AB' },
  { path: '/ad/affise-recalc/*', title: 'Пересчет affise' },
  { path: '/ad/blacklist/*', title: 'Блэк лист' },
  { path: '/ad/mapping/:network/*', title: 'Маппинг' },
  { path: '/ad/recalc/queue/*', title: 'Пересчет' },
  { path: '/ad/spots/*', title: 'Споты' },
  { path: '/ad/tabular/*', title: 'Расходы' },
  { path: '/ad/expenses/*', title: 'Расходы по нетворку' },
  { path: '/ad/revshare/*', title: 'RevShare' },
  { path: '/ad/*', title: 'Расходы' },
  { path: '/ltv/*', title: 'LTV' },
  { path: '/mx/settings/blacklist/*', title: 'Блэк лист' },
  { path: '/payments/game-days/*', title: 'По игровым дням' },
  { path: '/payments/raw/*', title: 'Когда-сколько' },
  { path: '/payments/top-users/*', title: 'По игрокам' },
  { path: '/payments/per-hour/*', title: 'По часам' },
  { path: '/payments/*', title: 'По дням' },
  { path: '/postbacks/*', title: 'Постбэки' },
  { path: '/reports/*', title: 'Отчеты' },
  { path: '/retention/export/*', title: 'Ретеншн экспорт' },
  { path: '/retention/*', title: 'Ретеншн' },
  { path: '/mx/hourly/*', title: 'По часам' },
  { path: '/mx/sessions/*', title: 'Сессии' },
  { path: '/summary/*', title: 'Summary' },
  { path: '/users/*', title: 'Поиск игроков' },
]

export default pageTitles
